import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=e7608ed6&scoped=true&"
import script from "./resources.vue?vue&type=script&lang=js&"
export * from "./resources.vue?vue&type=script&lang=js&"
import style0 from "./resources.vue?vue&type=style&index=0&id=e7608ed6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7608ed6",
  null
  
)

export default component.exports